import { createSlice } from "@reduxjs/toolkit";
import { getDataSession, LOCAL_STORAGE } from "../helper/session";

export const CURRENT_BIZZAPP = "current_bizzApp";

const initialState = {
  currentBizzApp: getDataSession(LOCAL_STORAGE, CURRENT_BIZZAPP) ?? null,
  currentMenu: [],
};

const bizzAppSlice = createSlice({
  name: "bizzApps",
  initialState,
  reducers: {
    setCurrentBizzApp(state, action) {
      state.currentBizzApp = action.payload;
    },
    setCurrentMenuApp(state, action) {
      state.currentMenu = action.payload;
    },
  },
});
const { actions, reducer } = bizzAppSlice;
export const { setCurrentBizzApp, setCurrentMenuApp } = actions;
export default reducer;
